import { useEffect, useState } from "react";
import { fetchWithAuth } from "../../../../../../../api-client/APIClient";

export const useFilterOptions = () => {
  const [integrationNames, setIntegrationNames] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isActive = true;

    fetchWithAuth({
      path: "/integrations/names",
      method: "GET",
      onResponse: (data: string[]) => {
        if (!isActive) return;
        setIntegrationNames(data);
        setIsLoading(false);
      },
      onError: () => {
        if (isActive) setIsLoading(false);
      },
    });

    return () => {
      isActive = false;
    };
  }, []);

  return { integrationNames, isLoading };
};
